// FLAGS: authorization
// The role numbers the UI gates on. They mirror the API's role enum by convention only — nothing generates or checks
// this file against the backend, so a renumbering there silently re-points every `hasRole` call in the dashboard.
export enum OpenUpRoles {
  Automation = 0,
  Guest = 1,
  Client = 2,
  Expert = 3,
  Admin = 4,
  Manager = 5,
  Consult = 6,
  Checkin = 7,
  Host = 8,
  Support = 11,
}
